export default __webpack_public_path__ + "static/media/img_02.4a8284be.webp";